import workersImg from "../../assets/Kikuyu water workers.jpeg";

const OverviewSection = () => {
  return (
    <section id="company-overview" className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          <div className="lg:col-span-2">
            <div className="inline-block bg-primary/10 px-4 py-2 rounded-full mb-4">
              <span className="text-primary font-bold text-sm">EXECUTIVE SUMMARY</span>
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-4 leading-tight">
              Serving the Kikuyu Community with Excellence
            </h2>
            <p className="text-base text-gray-700 mb-4 leading-relaxed">
              Kikuyu Water Company (kiwaco) provides water services within 
              Kikuyu and Kabete Sub-Counties, covering ten administrative wards 
              with a total projected population of 436,232 people, based on the 
              2019 census. The Company currently serves approximately 240,900 
              residents, translating to an overall water service coverage of 55 
              percent.
            </p>
            <p className="text-base text-gray-700 mb-4 leading-relaxed">
              The utility relies exclusively on groundwater sources, operating 43 
              boreholes, of which 31 are active, while several have been decommissioned 
              due to low yield and poor water quality. kiwaco has an installed design 
              production capacity of 17,200 m³ per day, with an additional 6,120 m³ per 
              day expected upon completion of ongoing borehole and network expansion 
              projects. At present, the Company produces an average of 11,000 m³ 
              per day, resulting in a persistent supply shortfall.
            </p>
            <p className="text-base text-gray-700 mb-4 leading-relaxed">
              The water supply infrastructure comprises approximately 33 kilometres
               of transmission pipelines and 560 kilometres of distribution networks, 
               supported by 41 storage tanks with a total capacity of 5,108 m³, of 
               which 3,950 m³ is usable storage. The system serves 18,836 registered 
               consumer connections, including 10,764 active connections, with 
               disconnections largely attributable to historical water shortages. 
               Reconnection efforts are ongoing as supply capacity improves.
            </p>
            <p className="text-base text-gray-700 mb-6 leading-relaxed">
              To mitigate the supply deficit, water provision is partially supplemented through Community Water Projects, estimated at 25 schemes, alongside private boreholes
            </p>
            <div className="flex flex-wrap gap-3">
              <button className="bg-primary text-white px-6 py-2.5 rounded-lg font-bold hover:bg-blue-700 transition text-sm">
                Download Company Profile
              </button>
              <button className="border-2 border-primary text-primary px-6 py-2.5 rounded-lg font-bold hover:bg-primary hover:text-white transition text-sm">
                View Annual Report
              </button>
            </div>
          </div>
          <div className="lg:col-span-1">
            <div className="bg-gradient-to-br from-primary to-blue-800 rounded-xl overflow-hidden h-[350px] sticky top-4">
              <img
                className="w-full h-full object-cover opacity-90"
                src={workersImg}
                alt="Kikuyu water workers"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OverviewSection;
